import React, {  useEffect } from "react";
import clicksound from "./music/click.mp3";
import { useTranslation } from "react-i18next";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationEN from "../components/language/en/translation_en.json";
import translationID from "../components/language/id/translation_id.json";

const resources = {
  en: {
    translation: translationEN,
  },
  id: {
    translation: translationID,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "en",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});
const DynamicModal = ({
  show,
  message,
  score,
  onReset,
  englishscore,
  levels,
}) => {
  const { t } = useTranslation();
    useEffect(() => {
      if (show) {
        updateGameHistory();
      }
    }, [show]);

  if (!show) return null;

  // Create an Audio instance for the click sound
  const audio = new Audio(clicksound);

  // Function to play the click sound
  const playClickSound = () => {
    audio.play();
  };

  const updateGameHistory = () => {
    // Get current date and time
    const currentDateTime = new Date();
    const formattedDateTime = `${currentDateTime
      .getDate()
      .toString()
      .padStart(2, "0")}/${(currentDateTime.getMonth() + 1)
      .toString()
      .padStart(2, "0")}/${currentDateTime.getFullYear()} ${currentDateTime
      .getHours()
      .toString()
      .padStart(2, "0")}:${currentDateTime
      .getMinutes()
      .toString()
      .padStart(2, "0")}`;

    // Create new history entry
    const newHistory = {
      date: formattedDateTime,
      level: levels,
      score: score,
      englishscore: englishscore,
    };

    // Get existing history from local storage
    const existingHistory =
      JSON.parse(localStorage.getItem("gameHistory")) || [];

    // Add the new history entry to the existing history
    const updatedHistory = [...existingHistory, newHistory];

    // Save updated history to local storage
    localStorage.setItem("gameHistory", JSON.stringify(updatedHistory));
    };

  return (
    <div className="modal-overlay-game flex items-center justify-center fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 z-50">
      <div className="modal-content-game bg-gambar p-5 text-center relative flex flex-col items-center lg:w-[25rem;] sm:w-[15rem]">
        <div className="modal-body-game mb-6">
          <h3 className="winner-title-game lg:text-4xl sm:text-lg font-bold">
            {t("game_over")}
          </h3>
          <p className="winner-name-game lg:text-2xl sm:text-sm font-bold rounded-lg lg:p-9 sm:p-2 ">
            {message}
          </p>
          <h3 className="score-title-game lg:p-3 lg:text-2xl sm:text-md sm:p-1 font-bold">
            {t("game_score")}
          </h3>
          <p className="score-game lg:text-3xl sm:text-xl font-bold">{score}</p>
          <h3 className="score-title-game lg:p-3 lg:text-2xl sm:text-md sm:p-1 font-bold">
            {t("english_score")}
          </h3>
          <p className="score-game lg:text-3xl sm:text-xl font-bold">
            {englishscore}
          </p>
        </div>
        <div className="modal-footer-game lg:mb-5">
          <button
            className="new-game-button block sm:mb-6 text-white font-bold py-2 px-4 rounded-full bg-blue-500 hover:bg-blue-600 shadow-lg transition-all duration-200 ease-in-out sm:text-xs lg:text-xl sm:px-2 md:text-xs"
            onClick={() => {
              playClickSound(); // Play the sound effect
              onReset(); // Call the onReset function
            }}
          >
            {t("play_again")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DynamicModal;
